import FeaturedCommunityMdSlideWrapper from '@new-components/atoms/FeaturedCommunityMdSlideWrapper';
import MuiBox from '@new-components/atoms/MuiBox';
import MuiContainer from '@new-components/atoms/MuiContainer';
import MuiSkeleton from '@new-components/atoms/MuiSkeleton';

import {CssVariables, MediaQuery} from '@constants/theme';

const UpcomingEventsSkeletonLoader = (): JSX.Element => {
  return (
    <>
      <MuiContainer
        sx={{
          padding: 0,
          paddingBottom: 8,
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
          [MediaQuery.desktop]: {
            paddingTop: 8,
            paddingBottom: 8,
          },
        }}>
        <MuiBox
          sx={{
            display: 'none',
            [MediaQuery.desktop]: {
              display: 'flex',
              flexDirection: 'column',
              gap: 2,
              px: `var(${CssVariables.mobilePadding})`,
            },
          }}>
          <MuiSkeleton
            variant='rounded'
            width='35%'
            height={37}
            animation='wave'
          />
        </MuiBox>
        <MuiBox
          sx={{
            display: 'none',
            [MediaQuery.desktop]: {
              display: 'flex',
              flexDirection: 'column',
              gap: 2,
              px: `var(${CssVariables.mobilePadding})`,
            },
          }}>
          <MuiSkeleton
            variant='rounded'
            width='45%'
            height={19}
            animation='wave'
          />
        </MuiBox>

        <FeaturedCommunityMdSlideWrapper>
          {Array.from({length: 4}, (_, i) => (
            <MuiSkeleton
              key={i}
              variant='rounded'
              width='25%'
              height={400}
              animation='wave'
            />
          ))}
        </FeaturedCommunityMdSlideWrapper>
      </MuiContainer>
    </>
  );
};
export default UpcomingEventsSkeletonLoader;
